import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonDropdown } from '../../../../models';
import { CurrentAuctionList } from '../../../../models/auctionList';
import {
  AuctionService,
  CategoryService,
  AuthenticationService,
  LoaderService,
  SaleTypeService,
} from '../../../../services';
import constants from '../../../../utility/constants';
import {  Subscription } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-auctions-list',
  templateUrl: './auctions-list.component.html',
  styleUrls: ['./auctions-list.component.css'],
})
export class AuctionsListComponent implements OnInit {
  showListView = true;
  sectionTitle: string;
  registerBidText: string;
  showPaginator: boolean = false;
  statusValue = constants.common.auctionStatus;
  isShowStatusFilter: boolean = false;
  private subscriptions: Array<Subscription> = [];

  currentAuctionType: string;
  backgroundPic: string = '';

  auctionStatuses = constants.common.auctionStatus;

  auctionType = {
    currentAuction: {
      title: 'CurrentAuction',
      bgPicture: '/assets/images/Current-Auction.jpg',
    },
    pastAuction: {
      title: 'PastAuction',
      bgPicture: '/assets/images/Past-Auctions.jpg',
    },
    turnKeySale: {
      title: 'TurnKeySale',
      bgPicture: '/assets/images/Past-Turn-Key-Sales.jpg',
    },
    machinery: {
      title: 'Machinery',
      bgPicture: '/assets/images/Machinery-Marketplace.jpg',
    },
    featuredPast: {
      title: 'FeaturedPast',
      bgPicture: '/assets/images/Past-Auctions.jpg',
    },
  };

  private sortOrderKeys = {
    ASCENDING: 'Ascending',
    DESCENDING: 'Descending',
  };

  private sortByKeys = {
    START_DATE_TIME: 'StartDateTime',
    END_DATE_TIME: 'EndDateTime',
    AUCTION_NAME: 'Name',
  };

  sortingObject: Array<CommonDropdown> = [
    {
      text: 'Start Date: Ascending',
      value: 1,
    },
    {
      text: 'Start Date: Descending',
      value: 2,
    },
    {
      text: 'End Date: Ascending',
      value: 3,
    },
    {
      text: 'End Date: Descending',
      value: 4,
    },
    {
      text: 'Auction Name: Ascending',
      value: 5,
    },
    {
      text: 'Auction Name: Descending',
      value: 6,
    },
  ];

  displaySectionDD: Array<CommonDropdown> = [
    {
      value: 1,
      text: 'All',
    },
    {
      value: 2,
      text: 'Current Auctions',
    },
    {
      value: 3,
      text: 'Turn Key Sales',
    },
  ];

  selectedDisplaySection: number;

  auctionData: Array<CurrentAuctionList>;
  totalAuction: number;

  // date functions
  isStartDate: boolean;
  isEndDate: boolean;

  // paging info
  saleType = 0;
  category = {
    text: '',
    value: 0
  }
  sortModel = {
    text: '',
    value: 0
  };
  searchTerm = '';
  pageNumber = 1;
  pageSize = 20;
  sortBy = '';
  sortOrder = '';
  isPaginated = true;
  onlyActive = false;
  auctionStatus = 0;
  displaySection = [];
  categories: Array<CommonDropdown>;
  searchControl = new FormControl();
  isInquireForm: number =
  constants.common.saletypeRegistrationFormat.inquiryForm;
  params: HttpParams = new HttpParams();

  isLoggedIn: boolean | null;
  private displaySections = constants.common.displaySection;

  constructor(
    private auctionService: AuctionService,
    private categoryService: CategoryService,
    private saletypeService: SaleTypeService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    this.getAuctionType();
    this.getCategories();
    this.getSaleTypes();

    this.isLoggedIn = this.authService.checkLoggedIn();

    if (this.auctionStatus == 4) {
      this.sortingObject.splice(0, 2);
    }

    this.route.queryParams.subscribe((params) => {
      let model = this.filterModel();
      if (params['searchTerm']) {
        model.searchTerm = params['searchTerm']
        this.searchTerm = params['searchTerm'];
      }
      if (params['category']) {
        model.category = params['category']
        this.category.value = parseInt(params['category'])
      }
      if (params['sortBy']) {
        model.sortBy = params['sortBy']
        this.sortBy = params['sortBy'];
      }
      if (params['sortOrder']) {
        model.sortOrder = params['sortOrder']
        this.sortOrder = params['sortOrder'];
        let sortValue = this.getSortValue(this.sortBy, this.sortOrder);
        this.sortModel = this.sortingObject.find(x => x.value === sortValue);
      }
      if (params['saleType']) {
        model.saleType = params['saleType']
        this.saleType = parseInt(params['saleType']);
      }
      if (params['pageNumber']) {
        model.pageNumber = params['pageNumber']
        this.pageNumber = parseInt(params['pageNumber']);
      }
      if (params['auctionStatus']) {
        model.auctionStatus = params['auctionStatus']
        this.auctionStatus = parseInt(params['auctionStatus']);
      }
      this.getCurrentAuctionsData();
    });
    this.searchFilter();
  }

  ///// this is the method which is responsible for differenciate the type of list to show
  ///// i.e. past or current or turn-key-sale
  getAuctionType() {
    let type: string;
    this.route.data.subscribe((data) => {
      this.sectionTitle = data['title'];
      type = data['type'];
    });

    let auctionStatus = constants.common.auctionStatus;
    this.currentAuctionType = type;

    switch (type) {
      case this.auctionType.currentAuction.title:
        this.selectedDisplaySection = 1; // for All
        this.auctionStatus = auctionStatus.liveUpcoming;
        this.displaySection = this.assignDisplaySectionForCurrentAuction();
        this.backgroundPic = this.auctionType.currentAuction.bgPicture;
        break;
      case this.auctionType.turnKeySale.title:
        this.auctionStatus = auctionStatus.past;
        this.displaySection = [this.displaySections.turnKey];
        this.backgroundPic = this.auctionType.turnKeySale.bgPicture;
        break;
      case this.auctionType.pastAuction.title:
        // updated to auctionStatus.archived to default to archived - set auctionStatus.past to revert
        this.auctionStatus = auctionStatus.archived;
        this.displaySection = [this.displaySections.auctionCalender];
        this.backgroundPic = this.auctionType.pastAuction.bgPicture;
        break;
      case this.auctionType.machinery.title:
        this.auctionStatus = auctionStatus.LiveUpcomingPast;
        this.displaySection = [this.displaySections.machinery];
        this.isShowStatusFilter = true;
        this.backgroundPic = this.auctionType.machinery.bgPicture;
        break;
      case this.auctionType.featuredPast.title:
        this.auctionStatus = auctionStatus.featuredPast;
        this.displaySection = [...this.displaySections.featuredPast];
        this.isShowStatusFilter = true;
        this.backgroundPic = this.auctionType.featuredPast.bgPicture;
        break;
    }
  }

  saletypesForDD: Array<{ text: string; value: number }>;

  getSaleTypes() {
    const saleType = this.saletypeService
      .getSaletypeForDropDownPublic(this.statusValue.liveUpcoming, [
        this.displaySections.auctionCalender,
        this.displaySections.turnKey,
      ])
      .subscribe((res) => {
        this.saletypesForDD = res;
      });
      this.subscriptions.push(saleType)
  }

  getCategories() {
    const category = this.categoryService.categoryForDropDown().subscribe((res) => {
      this.categories = res;
    });
    this.subscriptions.push(category)
  }

  categoryFilter(value) {
    if (value == null) this.category.value = 0;
    else this.category.value = value;
    this.getCurrentAuctionsData();
  }

  saletypeFilter(value) {
    this.saleType = value;
    this.getCurrentAuctionsData();
  }

  searchFilter() {
    this.searchControl.valueChanges
      .pipe(debounceTime(700))
      .subscribe((value) => {
        //this.pageNumber = 1;
        this.searchTerm = value;
        this.getCurrentAuctionsData();
      });
  }

  statusFilter(value: number) {
    this.auctionStatus = value;
    this.getCurrentAuctionsData();
  }

  displaySectionFilter(value: number) {
    this.selectedDisplaySection = value;
    this.getCurrentAuctionsData();
  }

  private assignDisplaySectionForCurrentAuction(): number[] {
    switch (this.selectedDisplaySection) {
      case 1:
        return [
          this.displaySections.turnKey,
          this.displaySections.auctionCalender,
        ];
      case 2:
        return [this.displaySections.auctionCalender];
      case 3:
        return [this.displaySections.turnKey];
      default:
        return null;
    }
  }

  resetSearch() {
    this.searchControl.reset();
  }

  sortFilter(value) {
    if (value == null) {
      this.sortBy = '';
      this.sortOrder = '';
    } else {
      switch (value) {
        case 1:
          this.sortBy = this.sortByKeys.START_DATE_TIME;
          this.sortOrder = this.sortOrderKeys.ASCENDING;
          break;
        case 2:
          this.sortBy = this.sortByKeys.START_DATE_TIME;
          this.sortOrder = this.sortOrderKeys.DESCENDING;
          break;
        case 3:
          this.sortBy = this.sortByKeys.END_DATE_TIME;
          this.sortOrder = this.sortOrderKeys.ASCENDING;
          break;
        case 4:
          this.sortBy = this.sortByKeys.END_DATE_TIME;
          this.sortOrder = this.sortOrderKeys.DESCENDING;
          break;
        case 5:
          this.sortBy = this.sortByKeys.AUCTION_NAME;
          this.sortOrder = this.sortOrderKeys.ASCENDING;
          break;
        case 6:
          this.sortBy = this.sortByKeys.AUCTION_NAME;
          this.sortOrder = this.sortOrderKeys.DESCENDING;
          break;
      }
    }
    this.getCurrentAuctionsData();
  }

  getSortValue(sortBy, sortOrder) {
    switch (sortBy) {
      case this.sortByKeys.START_DATE_TIME:
        return sortOrder === this.sortOrderKeys.ASCENDING ? 1 : 2;
      case this.sortByKeys.END_DATE_TIME:
        return sortOrder === this.sortOrderKeys.ASCENDING ? 3 : 4;
      case this.sortByKeys.AUCTION_NAME:
        return sortOrder === this.sortOrderKeys.ASCENDING ? 5 : 6;
      default:
        return null; // Handle the case where sortBy is not recognized.
    }
  }

  filterModel() {
    return {
      saleType: this.saleType,
      category: this.category.value,
      searchTerm: this.searchTerm,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
      isPaginated: this.isPaginated,
      onlyActive: this.onlyActive,
      auctionStatus: this.auctionStatus,
      displaySection:
        this.assignDisplaySectionForCurrentAuction() || this.displaySection,
    };
  }

  getCurrentAuctionsData() {
    this.showPaginator = false;
    this.loader.showLoader(true);
    let model = this.filterModel();
    const currentParams = { ...this.router.parseUrl(this.router.url).queryParams };
    let paramCopy = {...currentParams}
    const resetPageNumber = (paramName: string) => {
      if (this.pageNumber === 1) {
        return;
      }
      if (!paramCopy[paramName] && model[paramName]) {
        this.pageNumber = 1
        model.pageNumber = 1
      } else if (paramCopy[paramName] && paramCopy[paramName] != model[paramName]) {
        this.pageNumber = 1
        model.pageNumber = 1
      }
    }
    if (model.searchTerm) {
      resetPageNumber('searchTerm')
      currentParams['searchTerm'] = model.searchTerm;
    } else if (!model.searchTerm) {
      delete currentParams['searchTerm']
    }
    if (model.category) {
      resetPageNumber('category')
      currentParams['category'] = model.category;
    } else if (!model.category) {
      delete currentParams['category']
    }
    if (model.sortBy) {
      currentParams['sortBy'] = model.sortBy;
    } else if (!model.sortBy) {
      delete currentParams['sortBy']
    }
    if (model.sortOrder) {
      currentParams['sortOrder'] = model.sortOrder;
    } else if (!model.sortOrder) {
      delete currentParams['sortOrder']
    }
    if (model.saleType) {
      resetPageNumber('saleType')
      currentParams['saleType'] = model.saleType;
    } else if (!model.saleType) {
      delete currentParams['saleType']
    }
    if (model.pageNumber) {
      currentParams['pageNumber'] = model.pageNumber;
    } else if (!model.pageNumber) {
      delete currentParams['pageNumber']
    }
    if (model.auctionStatus) {
      resetPageNumber('auctionStatus')
      currentParams['auctionStatus'] = model.auctionStatus;
    } else if (!model.auctionStatus) {
      delete currentParams['auctionStatus']
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: currentParams,
    });
    const allCurrentAuctions = this.auctionService.getAllCurrentAuctions(model).subscribe(
      (res) => {
        this.loader.showLoader(false);
        this.showPaginator = true;
        this.auctionData = res.data;
        this.totalAuction = res.totalCount;
      },
      () => {
        this.loader.showLoader(false);
        this.showPaginator = false;
        this.auctionData = null;
        this.totalAuction = 0;
      }
    );
    this.subscriptions.push(allCurrentAuctions)
  }

  goToRegister(auctionId: number) {
    this.router.navigate([auctionId, 'register'], {
      relativeTo: this.route,
      queryParams: { returnTo: this.router.url },
    });
  }

  onPageChange(paging: number) {
    this.pageNumber = paging;
    this.getCurrentAuctionsData();
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // You can change this to 'auto' for instant scrolling
    });
  }

  switchToArchive() {
    this.auctionStatus = this.auctionStatuses.archived;
    this.displaySection = [this.displaySections.auctionCalender];
    this.getCurrentAuctionsData();
  }

  switchToRecent() {
    this.auctionStatus = this.auctionStatuses.past;
    this.displaySection = [this.displaySections.auctionCalender];
    this.getCurrentAuctionsData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
